export default __webpack_public_path__ + "static/media/Appraiser.d0783cfb.png";